import { UseQueryOptions, useQuery } from 'react-query'

import { IUser, IUserFilterParams } from '~/utils/types'
import { getUserById, listAllUsers, listUserPaginated } from './userApi'

const useGetUserById = (userId: string, queryOptions?: UseQueryOptions<IUser>) => {
  return useQuery<IUser>({
    queryKey: ['get_user_by_id', userId],
    queryFn: () => getUserById(userId),
    ...queryOptions,
  })
}

const useListUserPaginated = (paginationParams: IUserFilterParams) => {
  return useQuery({
    queryKey: ['list_users_paginated', paginationParams],
    queryFn: () => listUserPaginated(paginationParams),
    staleTime: 5 * 1000,
    keepPreviousData: true,
  })
}

export interface IUseListAllUsers {
  show_all_users: boolean
}

const useListAllUsers = (params?: IUseListAllUsers) => {
  return useQuery({
    queryKey: ['list_all_users'],
    queryFn: () => listAllUsers(params),
    staleTime: 5 * 1000,
  })
}

export function useUserData() {
  return {
    useListAllUsers,
    useGetUserById,
    useListUserPaginated,
  }
}
